module.exports = __webpack_public_path__ + "static/img/icon-risk.4313191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-risk.png
// module id = OAEJ
// module chunks = 21